import Vue from 'vue'
import Vuex from 'vuex'

import accounts from './modules/accounts'
import categories from './modules/categories'
import shappy from './modules/shappy'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    accounts,
    categories,
    shappy
  }
})
